/**
 * The mouse's side buttons, as keys. The browser reads buttons 4 and 5 as
 * « back » and « forward » and would leave the game; here they never reach
 * it, and each press is passed on as a key press of code `Mouse4` / `Mouse5`,
 * so every shortcut (`isAction`) and the settings window's capture take them
 * like any other key (SHE-25).
 */

/** `MouseEvent.button` of the side buttons, and the code their press is given. */
const SIDE_BUTTONS: Readonly<Record<number, string>> = { 3: 'Mouse4', 4: 'Mouse5' };

/** The key code a mouse button stands for, if it is a side button. */
export function mouseButtonCode(button: number): string | undefined {
  return SIDE_BUTTONS[button];
}

let installed = false;

export function installMouseButtons(): void {
  if (installed) return;
  installed = true;
  // Chrome navigates on mouseup, Firefox on mousedown or auxclick: all three are stopped.
  const block = (event: MouseEvent): void => {
    if (mouseButtonCode(event.button) !== undefined) event.preventDefault();
  };
  window.addEventListener('mouseup', block, { capture: true });
  window.addEventListener('auxclick', block, { capture: true });
  window.addEventListener(
    'mousedown',
    (event) => {
      const code = mouseButtonCode(event.button);
      if (code === undefined) return;
      event.preventDefault();
      window.dispatchEvent(
        new KeyboardEvent('keydown', {
          key: '',
          code,
          metaKey: event.metaKey,
          ctrlKey: event.ctrlKey,
          altKey: event.altKey,
          shiftKey: event.shiftKey,
          bubbles: true,
          cancelable: true,
        }),
      );
    },
    { capture: true },
  );
}
